import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.Export.IRequest;
type Response = Api.Core.Contract.Export.IResponse;
type Headers = Api.Core.Contract.Export.IHeaders;
const url = '/api/Sales/Contract/ExportToExcel';
export default async function contractExportApi(query: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, query),
    headers: getDefaultHeaders(),
  });
}
